// fetch接口请求

import { fetch } from '@/common/request';

export interface AiModelListVo {
  id: number;
  modelName: string;
  modelType: string;
  status: boolean;
}

export interface ModelProviderVo {
  id: number;
  providerZh: string;
  apiKey: string;
  baseUrl?: string;
  status?: boolean;
  logo?: string;
  aiModelList?: AiModelListVo[];
}

export interface ModelProviderInfo {
  id: number;
  apiKey?: string;
  baseurl?: string;
  status?: boolean;
}

export interface UpdateModelStatusVo {
  id: number;
  status: boolean;
}

export function updateModelStatus(params: UpdateModelStatusVo): Promise<any> {
  return fetch(
    '/api/modelConfig/model/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 修改模型供应商
export function updateModelConfigProvider(params: ModelProviderInfo): Promise<any> {
  return fetch(
    '/api/modelConfig/provider/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 模型列表
export function getModelList(): Promise<ModelProviderVo[]> {
  return fetch(
    '/api/modelConfig/list',
    {
      method: 'POST',
    },
    true
  );
}
